import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage, showError, confirmAction } from '../../actions/uiActions';
import Users from '../../components/Users';
import Auth from '../../api/auth';
import CRMReport from '../../components/CRMReport';
import { withRouter } from '../../utils/withRouter';


class HomeComponent extends Component {
    state = {
        mode: "default",
        report: false
    }

    render() {
        return <section className="animated fadeIn wide">
            <header>
                <h1>Users</h1>
                <div className="actions">
                    {Auth.account.role === "admin" && <Tooltip title="Download CRM Report"><button onClick={() => this.setState({ report: true })}>
                        Download CRM Report
                    </button></Tooltip>}
                </div>
            </header>
            <Users onAccountSelected={(id) => this.props.history.push(`/users/${id}?source=${this.props.location.pathname}${this.props.location.search}`)} />
            {this.state.report && <CRMReport onClose={() => this.setState({ report: false })} />}
        </section>
    }
}
const mapStateToProps = state => {
    return state
};
HomeComponent.propTypes =
{
    showMessage: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    confirmAction: PropTypes.func.isRequired
};
export default withRouter(connect(mapStateToProps, { showMessage, showError, confirmAction })(HomeComponent));